import PropTypes from 'prop-types';
// @mui
import { LoadingButton } from '@mui/lab';
import { alpha, styled } from '@mui/material/styles';

import { Box, Button, Container, Typography, DialogActions, Dialog, Divider, Paper, Card } from '@mui/material';
// components
import Image from '../../../components/image';
import Scrollbar from '../../../components/scrollbar';
import EmptyContent from '../../../components/empty-content';
import Markdown from '../../../components/markdown';
import { useSettingsContext } from '../../../components/settings';
import { fDate } from '../../../utils/formatTime';
import VideoPlayer from "../../admin/preview/videoplayer";
import DocumentViewer from "../../admin/preview/documentviewer";
// ----------------------------------------------------------------------

BlogNewPostPreview.propTypes = {
    open: PropTypes.bool,
    isValid: PropTypes.bool,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    values: PropTypes.object,
    videoFiles: PropTypes.array,
    documentFiles: PropTypes.array,
    isSubmitting: PropTypes.bool,
    editorContent: PropTypes.string,
    topicType: PropTypes.string,
    createdDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date)
    ]),
};

export default function BlogNewPostPreview({
    values,
    isValid,
    isSubmitting,
    open,
    onClose,
    onSubmit,
    createdDate,
    editorContent,
    topicType,
    videoFiles,
    documentFiles

}) {

    // console.log('values', values);
    const { title = '', article = '', description = '', types = '' } = values;

    const cover = typeof values.cover === 'string' ? values.cover : values.cover?.preview;

    const hasContent = title || description || article || cover || videoFiles || documentFiles ;

    const hasHero = title || cover;

    const { themeStretch } = useSettingsContext();
   
    return (
        <Container maxWidth={themeStretch ? false : 'lg'}>

            <Dialog fullScreen open={open} onClose={onClose}>

                <DialogActions sx={{ py: 2, px: 3 }}>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        Preview
                    </Typography>

                    <Button variant="outlined" color="inherit" onClick={onClose}>
                        Cancel
                    </Button>

                    <LoadingButton
                        type="submit"
                        variant="contained"
                        disabled={!isValid}
                        loading={isSubmitting}
                        onClick={onSubmit}
                    >
                        Save
                    </LoadingButton>
                </DialogActions>

                {/* <Divider sx={{ mb: 4 }} /> */}
                {hasContent && (videoFiles.length !== 0 || documentFiles.length !== 0 || article.length !== 0) ? (

                    <Scrollbar>

                        {types === '1' &&
                            <>
                                <Paper sx={{ px: 4, mx: 4 }}>
                                    <Typography variant="h2">
                                        {title}
                                    </Typography>
                                    <Typography variant="subtitle2" sx={{ mt: 3 }}>
                                        {description}
                                    </Typography>
                                   <Markdown children={article} /> 
                                </Paper>
                            </>
                        }


                        {types === '3' &&
                            <>
                                <Card sx={{ p: 4, m: 4, height: 'auto' }}>
                                    <VideoPlayer sourceURL={videoFiles} />
                                </Card>
                                <Paper sx={{ p: 4, m: 4 }}>
                                    <Typography variant="h5">
                                        {title}
                                    </Typography>


                                    <Typography variant="subtitle2" sx={{ mt: 3 }}>
                                        {description}
                                    </Typography>
                                </Paper>
                            </>
                        }

                        {types === '2' &&
                            <>
                            <Paper sx={{ p: 2, m: 2 }}>
                                <Typography variant="h5">
                                    {title}
                                </Typography>
                                <Typography variant="subtitle2" sx={{ mt: 3 }}>
                                    {description}
                                </Typography>
                            </Paper>
                            <Card sx={{ p: 4, m: 4, height: 'auto' }}>

                                <DocumentViewer documentSource={documentFiles} />
                            </Card>

                            </>
                        }

                        {/* {hasHero && <PreviewHero title={title} cover={cover} createdAt={createdDate} sx={{ m: 2 }} />}  */}

                    </Scrollbar>
                ) : (
                    <EmptyContent title="Empty content" />
                )}
            </Dialog>
        </Container >

    );
}

// ----------------------------------------------------------------------

const StyledOverlay = styled('div')(({ theme }) => ({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 9,
    position: 'absolute',
    backgroundColor: alpha(theme.palette.grey[900], 0.64),
}));

const StyledTitle = styled('h1')(({ theme }) => ({
    ...theme.typography.h3,
    top: 0,
    zIndex: 10,
    width: '100%',
    position: 'absolute',
    padding: theme.spacing(3),
    color: theme.palette.common.white,
    [theme.breakpoints.up('md')]: {
        ...theme.typography.h2,
        padding: theme.spacing(5),
    },
    [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(10),
    },
}));

const StyledFooter = styled('div')(({ theme }) => ({
    bottom: 0,
    zIndex: 10,
    width: '100%',
    display: 'flex',
    position: 'absolute',
    alignItems: 'flex-end',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(3),
    justifyContent: 'space-between',
    [theme.breakpoints.up('sm')]: {
        alignItems: 'center',
        paddingRight: theme.spacing(3),
    },
    [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(10),
    },
}));

PreviewHero.propTypes = {
    cover: PropTypes.string,
    title: PropTypes.string,
    createdAt: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date)
    ]),
};

function PreviewHero({ title, cover, createdAt }) {

    return (
        <Box
            sx={{
                overflow: 'hidden',
                position: 'relative',
                borderRadius: {
                    xs: `16px 16px 16px 16px`,
                    md: `16px 16px 16px 16px`,
                },
            }}
        >
            <StyledTitle>{title}</StyledTitle>

            <StyledFooter>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {/*   <Avatar alt={author.name} src={author.avatarUrl} sx={{ width: 48, height: 48 }} />  */}

                    <Box sx={{ ml: 2 }}>
                        {/* <Typography variant="subtitle1" sx={{ color: 'common.white' }}> */}
                        {/*  {author.name}  */}
                        {/* </Typography>   */}

                        <Typography variant="body2" sx={{ color: 'grey.500' }}>
                            {fDate(createdAt)}
                        </Typography>
                    </Box>
                </Box>

                {/* <SpeedDial  */}
                {/*  direction={isDesktop ? 'left' : 'up'}  */}
                {/*  ariaLabel="Share post" */}
                {/*  icon={<Iconify icon="eva:share-fill" />}   */}
                {/*  sx={{ '& .MuiSpeedDial-fab': { width: 48, height: 48 } }}  */}
                {/* >    */}
                {/*  {_socials.map((action) => (    */}
                {/*    <SpeedDialAction */}
                {/*      key={action.name}  */}
                {/*      icon={<Iconify icon={action.icon} sx={{ color: action.color }} />} */}
                {/*      tooltipTitle={action.name} */}
                {/*      tooltipPlacement="top" */}
                {/*      FabProps={{ color: 'default' }}    */}
                {/*    />   */}
                {/*  ))}    */}
                {/* </SpeedDial>    */}
            </StyledFooter>

            <StyledOverlay />

            <Image alt="cover" src={cover} ratio="16/9" />
        </Box>
    );
}
